import { useEffect, useState, useCallback } from "react";
import { getAllLoanInfo, getSupplementData, getAllCity, getLoanOfficers, getFundSource, getAllCounty, getAllLoanStatus } from "../Service";
import useBorrowerType from "app/views/borrowerType/hooks/useBorrowerType";
import useLoanType from "app/views/loantype/hooks/useLoanType";


const useSupplementsData = () => {
    const [loannums, setLoanNums] = useState([]);
    const [citys, setCitys] = useState([]);
    const [countys, setCountys] = useState([]);
    const [loanofficers, setLoanOfficers] = useState([]);
    const [fundSources, setFundSources] = useState([]);
    const { borrowerTypeList, updatePageData: updateBorrowerTypes } = useBorrowerType();
    const { loanTypes, updatePageData: updateLoanTypes } = useLoanType();
    const [loanStatusList, setLoanStatusList] = useState([]);

    const fetchAllLoanStatus = useCallback(() => {
        getAllLoanStatus().then(response => {
            console.log(response);
            setLoanStatusList(response.data.loanStatus || []);
        }).catch(error => {
            console.error('Failed to fetch loan status data', error);
        });
    }, []);

    const fetchDropdownData = useCallback(() => {
        getAllLoanInfo().then(response => {
            setLoanNums(response.data.loanInfos || []);
        }).catch(error => {
            console.error('Failed to fetch Loan Info data', error);
        });
    }, []);

    const fetchCityData = useCallback(() => {
        getAllCity().then(response => {
            console.log('City Data Response:', response);
            setCitys(response.data.citys || []);
        }).catch(error => {
            console.error('Failed to fetch City data', error);
        });
    }, []);

    const fetchCountyData = useCallback(() => {
        getAllCounty().then(response => {
            setCountys(response.data.countys || []);
        }).catch(error => {
            console.error('Failed to fetch County data', error);
        });
    }, []);

    const fetchLoanOfficers = useCallback(() => {
        getLoanOfficers().then(response => {
            console.log('Loan Officers Response:', response);
            setLoanOfficers(response.data || []);
        }).catch(error => {
            console.error('Failed to fetch City data', error);
        });
    }, []);

    const fetchFundSources = useCallback(() => {
        getFundSource().then(response => {
            console.log('Fund Sources Response:', response);
            setFundSources(response.data || []);
        }).catch(error => {
            console.error('Failed to fetch Fund Sources data', error);
        });
    }, []);

    const fetchSupplementData = async (params) => {
        try {
            console.log('Fetching supplement data with params:', params);
            const response = await getSupplementData(params);

            console.log('Parsed Supplement:', response.data);
            return response.data;
        } catch (err) {
            console.error('Error fetching supplement data:', err);
        }
    };

    useEffect(() => {
        fetchDropdownData();
        fetchCityData();
        fetchCountyData();
        fetchLoanOfficers();
        fetchFundSources();
        updateBorrowerTypes();
        updateLoanTypes();
        fetchAllLoanStatus();
    }, []);

    return { loannums, citys, countys, loanofficers, borrowerTypeList, loanTypes, loanStatusList, fundSources, fetchSupplementData };
};

export default useSupplementsData;
